import type { QueryKey } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const buildInvestmentProgrammeDocumentQueryKey = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
}: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}): QueryKey => [
	formatUnicorn(
		API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_GET,
		{ dealId, programmeId, documentWorkflowInstanceId }
	),
];

export const buildInvestmentProgrammeDocumentsListKeyPrefix = ({
	dealId,
	programmeId,
}: {
	dealId: string;
	programmeId: string;
}): QueryKey => [
	formatUnicorn(API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_LIST_GET, {
		dealId,
		programmeId,
	}),
];
